export default __webpack_public_path__ + "static/media/shrimp_tacos.77628334.jpeg";